"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _buttonsModule = _interopRequireDefault(require("@albelli/arc-3/lib/buttons.module.css"));
var _listModule = _interopRequireDefault(require("@albelli/arc-3/lib/list.module.css"));
var _panelModule = _interopRequireDefault(require("@albelli/arc-3/lib/panel.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ListItem = _ref => {
  let {
    className,
    children,
    clickable = true,
    ...props
  } = _ref;
  // TODO: fix references to panel and button components
  const classes = (0, _classnames.default)([_listModule.default["arc3-list--item"]], className);
  const contentClasses = (0, _classnames.default)({
    "arc3-pointer": clickable,
    [_buttonsModule.default["arc3-btn-hover"]]: clickable,
    [_listModule.default["arc3-list--item-content"]]: clickable,
    [_panelModule.default["arc3-panel"]]: !clickable
  }, "arc3-no-padding");
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: contentClasses
  }, children));
};
exports.ListItem = ListItem;
ListItem.propTypes = {
  /** Any content */
  children: _propTypes.default.any,
  /** Should the list item show an internal content box that has a hover effect */
  clickable: _propTypes.default.bool,
  /** If not clickable forceBorder allows us to force the border to be added (substitutes with a panel)  */
  forceBorder: _propTypes.default.bool
};